import { createSlice } from '@reduxjs/toolkit'
import { merge } from 'components/util'
import ProcessedMediaStates from './processed-media-states-model'
import {
  CreateProcessedMediaStatesAsync,
  DeleteProcessedMediaStatesAsync,
  LoadProcessedMediaStatessAsync,
} from './processedMediaStates-thunk'
const initialState: processedMediaStatesSliceState = {
  processedMediaStates: [],
  selected_processedMediaStates: '',
  is_loading_processedMediaStates: false,
  is_creating_processedMediaStates: false,
  is_deleting_processedMediaStates: false,
}
export interface processedMediaStatesSliceState {
  processedMediaStates: ProcessedMediaStates[]
  selected_processedMediaStates?: string
  is_loading_processedMediaStates: boolean
  is_creating_processedMediaStates: boolean
  is_deleting_processedMediaStates: boolean
}
export const processedMediaStatesSlice = createSlice({
  name: 'processedMediaStates',
  initialState,
  reducers: {
    setSelectedprocessedMediaStates: (state, action) => {
      state.selected_processedMediaStates = action.payload
    },
    clearStateprocessedMediaStates: (state) => {
      state.processedMediaStates = []
      state.is_loading_processedMediaStates = false
      state.is_creating_processedMediaStates = false
      state.is_deleting_processedMediaStates = false
    },
    mergeprocessedMediaStates: (state, action) => {
      if (action.payload) {
        let payload: any = action.payload
        if (payload?.data) {
          if (!Array.isArray(payload.data)) {
            state.selected_processedMediaStates = payload?.data?.id
            payload = [payload.data]
          } else {
            payload = payload.data
          }
          state.processedMediaStates = merge(
            state.processedMediaStates,
            payload,
          ) as any
        }
      }
    },

    add_processedMediaStates: (state, action) => {
      if (action.payload) {
        state.processedMediaStates = [
          ...state.processedMediaStates,
          action.payload,
        ]
      }
    },
    set_processedMediaStates: (state, action) => {
      let { key, value, id } = action.payload
      state.processedMediaStates = state.processedMediaStates.map((item) => {
        if (item && item.id === id) {
          return {
            ...item,
            [key]: value,
          }
        }
        return item
      })
    },
  },
  extraReducers: (builder) => {
    builder.addCase('LOGOUT', () => {
      return { ...initialState }
    })

    builder.addCase(LoadProcessedMediaStatessAsync.pending, (state) => {
      state.is_loading_processedMediaStates = true
    })
    builder.addCase(
      LoadProcessedMediaStatessAsync.fulfilled,
      (state, action) => {
        state.is_loading_processedMediaStates = false
        if (action.payload) {
          state.processedMediaStates = action.payload
        }
      },
    )
    builder.addCase(LoadProcessedMediaStatessAsync.rejected, (state) => {
      state.is_loading_processedMediaStates = false
    })
    builder.addCase(CreateProcessedMediaStatesAsync.pending, (state) => {
      state.is_creating_processedMediaStates = true
    })
    builder.addCase(CreateProcessedMediaStatesAsync.fulfilled, (state) => {
      state.is_creating_processedMediaStates = false
    })
    builder.addCase(CreateProcessedMediaStatesAsync.rejected, (state) => {
      state.is_creating_processedMediaStates = false
    })
    builder.addCase(DeleteProcessedMediaStatesAsync.pending, (state) => {
      state.is_deleting_processedMediaStates = true
    })
    builder.addCase(
      DeleteProcessedMediaStatesAsync.fulfilled,
      (state, action) => {
        state.is_deleting_processedMediaStates = false
        if (state.processedMediaStates) {
          state.processedMediaStates = state.processedMediaStates.filter(
            (x) => action.payload.id !== x.id,
          )
        }
      },
    )
    builder.addCase(DeleteProcessedMediaStatesAsync.rejected, (state) => {
      state.is_deleting_processedMediaStates = false
    })
  },
})

export const {
  clearStateprocessedMediaStates,
  setSelectedprocessedMediaStates,
  set_processedMediaStates,
  mergeprocessedMediaStates,
  add_processedMediaStates,
} = processedMediaStatesSlice.actions

export const get_processedMediaStates =
  (id?: string) =>
  (state: {
    processedMediaStates: {
      processedMediaStates: ProcessedMediaStates[]
    }
  }): ProcessedMediaStates | null => {
    let temp = state?.processedMediaStates?.processedMediaStates?.find(
      (v) => v.id === id,
    )
    if (temp) {
      return temp
    }
    return state?.processedMediaStates?.processedMediaStates[0] || null
  }
export const get_selected_processedMediaStates = (state: {
  processedMediaStates: processedMediaStatesSliceState
}): ProcessedMediaStates | null => {
  let id = state?.processedMediaStates?.selected_processedMediaStates
  let temp = state?.processedMediaStates?.processedMediaStates?.find(
    (v) => v.id === id,
  )
  if (temp) {
    return temp
  }
  return null
}
export const get_all_processedMediaStates = (state: {
  processedMediaStates: {
    processedMediaStates: ProcessedMediaStates[]
  }
}): ProcessedMediaStates[] => {
  let temp = state?.processedMediaStates?.processedMediaStates
  if (temp) {
    return temp.filter((x) => !x.deleted)
  }
  return []
}
export const is_processedMediaStates_busy = (state: {
  processedMediaStates: processedMediaStatesSliceState
}) => {
  return (
    state?.processedMediaStates.is_deleting_processedMediaStates ||
    state?.processedMediaStates.is_loading_processedMediaStates ||
    state?.processedMediaStates.is_creating_processedMediaStates
  )
}
export const is_deleting_processedMediaStates_busy = (state: {
  processedMediaStates: processedMediaStatesSliceState
}) => {
  return state?.processedMediaStates.is_deleting_processedMediaStates
}
export const is_loading_processedMediaStates_busy = (state: {
  processedMediaStates: processedMediaStatesSliceState
}) => {
  return state?.processedMediaStates.is_loading_processedMediaStates
}
export const is_creating_processedMediaStates_busy = (state: {
  processedMediaStates: processedMediaStatesSliceState
}) => {
  return state?.processedMediaStates.is_creating_processedMediaStates
}

export default processedMediaStatesSlice.reducer
